import { Injectable } from '@angular/core';
import { Router, NavigationEnd, Event as RouterEvent } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter } from 'rxjs/operators';
import { resetVoidAppliedFilters, resetVoidFilterPayload } from '@app/state/actions/app.action';

@Injectable({
  providedIn: 'root',
})
export class RouteGuardService {
  constructor(
    private router: Router,
    private store: Store,
  ) {
    this.router.events
      .pipe(filter((event: RouterEvent): event is NavigationEnd => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        this.handleRouteChange(event.urlAfterRedirects);
      });
  }

  private handleRouteChange(url: string): void {
    // Define routes that should not trigger a reset
    const nonResetRoutes = ['/void/detail', '/void'];

    // If current URL doesn't match any of the non-reset routes, dispatch reset action
    if (!nonResetRoutes.some((route) => url.startsWith(route))) {
      this.store.dispatch(resetVoidFilterPayload());
      this.store.dispatch(resetVoidAppliedFilters());
    }
  }
}
